module.exports = __webpack_public_path__ + "img/Iceland.c8b17430.svg";